import { useQuery, gql } from '@apollo/client'
import * as React from 'react'
import { InputBase, Icon, Dialog, Button, IconButton } from '@material-ui/core'
import { ModalProps } from '@material-ui/core/Modal'
import { Header, Loading, Error } from 'components'
import CardResource from '../../Card/Resource'
import * as Immutable from 'immutable'
import { useTranslation } from 'i18n'

type Props = {
  onComplete: Function
  onClose: React.MouseEventHandler
  type?: string
  value?: string
} & Pick<ModalProps, 'open'>

const Component: React.FC<Props> = ({
  open,
  onClose,
  onComplete,
  value,
  type,
}) => {
  const { t } = useTranslation('components')
  const { data, error, loading, fetchMore } = useQuery<
    QueryResult<{
      id: string
    }>
  >(GET_RESOURCE_BY_TYPE, {
    variables: { type },
  })
  const { resources: { edges = [], pageInfo = {} } = {} } = data || {}

  const onLoadMore = () => {
    fetchMore({
      variables: { pageInput: { cursor: pageInfo.endCursor } },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev

        return Immutable.fromJS(fetchMoreResult)
          .updateIn(['resources', 'edges'], edges => [
            ...prev.resources.edges,
            ...edges,
          ])
          .toJS()
      },
    })
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <div style={{ width: 600, height: 500 }}>
        <Header.Base style={{ display: 'flex' }}>
          <div style={{ flex: '1 1 auto' }}>
            <IconButton onClick={onClose}>
              <Icon>close</Icon>
            </IconButton>
          </div>
          <div style={{ margin: 'auto' }}></div>
        </Header.Base>
        <div>
          {loading ? (
            <Loading />
          ) : error ? (
            <Error>{error}</Error>
          ) : edges.length ? (
            <div>
              {edges.map(({ node: resource }) => {
                return (
                  <CardResource
                    key={resource.id}
                    onClick={() => {
                      onComplete(resource)
                    }}
                    style={{ margin: 10 }}
                  >
                    {resource}
                  </CardResource>
                )
              })}
              {pageInfo.hasNextPage && (
                <div style={{ textAlign: 'center' }}>
                  <Button onClick={onLoadMore}>
                    {t('Input.ResourceDialog.loadMore')}
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <p>{t('Input.ResourceDialog.noSavedContent')}</p>
          )}
        </div>
      </div>
    </Dialog>
  )
}

interface QueryResult<T = {}> {
  resources: {
    pageInfo: any
    edges: Array<{
      node: T
    }>
  }
}

export default Component

const GET_RESOURCE_BY_TYPE = gql`
  query($pageInput: PageInputDate, $type: String) {
    resources(pageInput: $pageInput, type: $type)
      @connection(key: "resources", filter: ["type"]) {
      edges {
        node {
          ... on Resource {
            id
            name
            type
            uri
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`
